module.exports = __webpack_public_path__ + "img/back-button.29ddcc7e.svg";